<div class="db-payments-intro">
  <div class="db-payments-intro__info">
    <div class="db-payments-intro__logo">
      <i class="db-icon db-icon-ds-ecommerce"></i>
    </div>
    <div class="mt15">
      <h1 [innerHTML]="'text_acceptPaymentsInstantlyWithPaymentsPoweredByStripe' | dbText"></h1>
      <p class="mt10" [innerHTML]="'text_processingPaymentsWithASecureFastAndSeamlessCheckout' | dbText"></p>
    </div>
    <div class="mt30">
      <a class="ds-btn-purple-blue ds-btn-l rectangle" (click)="openOneWeekFreeDialog()" [ngClass]="{'ds-btn-disabled': !!loading}">
        <span *ngIf="!loading">{{ 'text_setUp' | dbText }}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
  <div class="db-payments-intro__list">
    <ng-container *ngFor="let info of paymentInfoList; let i = index">
      <div [ngClass]="{'mt30': i !== 0}" class="db-payments-intro__list-item">
        <i class="db-icon db-icon-ds-checkmark-small mt4"></i>
        <div>
          <h1 [innerHTML]="info?.title"></h1>
          <p class="mt5" [innerHTML]="info?.desc"></p>
        </div>
      </div>
    </ng-container>
  </div>
</div>
